import React from "react";
import styled from "styled-components";
import { Table as BsTable } from "react-bootstrap";
import { ItemListadoServiciosGuarderia } from '../../../services/guarderiaServicios';
import { useNavigate } from "react-router-dom";
import { RUTA_SERVICIOS_GUARDERIA } from "../../../services/rutas";
import { currencyFormat } from "../../../utils/numberUtils";


function Table({ items, puedeEditar }: TableSectionProps) {
    return (
        <StyledTable responsive hover>
            <thead>
                <tr>
                    <StyledColHeader>Nombre</StyledColHeader>
                    <StyledColHeader>Días</StyledColHeader>
                    <StyledColHeader>Precio Total</StyledColHeader>
                    <StyledColHeader>Descripción</StyledColHeader>
                </tr>
            </thead>
            <tbody>
                {
                    items.map((_, index) => <TableItem key={_.id} item={_} puedeEditar={puedeEditar}/>)
                }
            </tbody>
        </StyledTable>
    );
}

interface TableSectionProps {
    items: ItemListadoServiciosGuarderia[];
    puedeEditar: boolean;
}

interface TableItemProps {
    item: ItemListadoServiciosGuarderia;
    puedeEditar: boolean;
}

function TableItem({ item, puedeEditar }: TableItemProps){
    let navigate = useNavigate();

    const onRowClick = () => {
      if (!puedeEditar) return;
      navigate(`${RUTA_SERVICIOS_GUARDERIA}/${item.id}`, { replace: false });
    };

    return (
        <StyledRow onClick={onRowClick} $clickable={puedeEditar}>
            <StyledCell>{item.nombre}</StyledCell>
            <StyledCell>{item.dias}</StyledCell>
            <StyledCell>{currencyFormat(item.precioTotal)}</StyledCell>
            <StyledCell>{item.descripcion}</StyledCell>
        </StyledRow>
    );
}



const StyledTable = styled(BsTable)`

`

const StyledCell = styled("td")`

`

const StyledColHeader = styled("th")`
    color: ${props => props.theme.colors.main};
`

const StyledRow = styled("tr")<{ $clickable?: boolean }>`
    cursor: ${props => props.$clickable ? "pointer" : "default"};
`

export default Table;